<template>
	<div class="content_box">
		<div class="title">
			<span class="left_shu"></span>
			站点管理
		</div>
		<div class="operation">
			<a-button class="creatadd" type="primary" @click="addModal">
				创建站点
			</a-button>
			<div class="sinput">
				<input type="text" placeholder="请输入站点名称查询" />
				<!-- <img src="../assets/images/37.png" /> -->
			</div>
		</div>
		<a-table :columns="columns" :data-source="data">
			<span slot="tags" slot-scope="text,tags">
				<a class="edit_btn" @click="() => editModal(tags)">编辑</a>
				<a class="delete_btn" @click="() => deleteBtn(tags)">删除</a>
			</span>
		</a-table>

		<!-- 添加弹窗 -->
		<div class="addbox" ref="add">
			<a-modal v-model="visible" :title="title" @ok="handleOk" :getContainer="()=>$refs.add" okText="确认"
				cancelText="取消" width='490px'>
				<div class="frame_list_box">
					<a-row type="flex">
						<a-col :span="2" :order="1">
							<div class="frame_list_title">
								类型
							</div>
						</a-col>
						<a-col :span="16" :order="2">
							<a-select :default-value="projectForm.type" style="width: 180px" @change="handleChange">
								<a-select-option v-for="(item,index) in formType" :key='index' :value="item.value">
									{{item.name}}
								</a-select-option>
							</a-select>
						</a-col>
					</a-row>
				</div>
				<div class="frame_list_box">
					<a-row type="flex">
						<a-col :span="2" :order="1">
							<div class="frame_list_title">
								名称
							</div>
						</a-col>
						<a-col :span="10" :order="2">
							<a-input type="text" style="width: 150px;" v-model='projectForm.name' />
						</a-col>
						<a-col :span="2" :order="3">
							<div class="frame_list_title">
								站号
							</div>
						</a-col>
						<a-col :span="10" :order="4">
							<a-input type="text" style="width: 150px;" v-model='projectForm.number' />
						</a-col>
					</a-row>
				</div>
				<div class="frame_list_box">
					<a-row type="flex">
						<a-col :span="2" :order="1">
							<div class="frame_list_title">
								经度
							</div>
						</a-col>
						<a-col :span="10" :order="2">
							<a-input type="text" style="width: 150px;" v-model='projectForm.longitude' />
						</a-col>
						<a-col :span="2" :order="3">
							<div class="frame_list_title">
								纬度
							</div>
						</a-col>
						<a-col :span="10" :order="4">
							<a-input type="text" style="width: 150px;" v-model='projectForm.latitude' />
						</a-col>
					</a-row>
				</div>
				<div class="frame_list_box">
					<a-row type="flex">
						<a-col :span="2" :order="1">
							<div class="frame_list_title">
								海拔
							</div>
						</a-col>
						<a-col :span="10" :order="2">
							<a-input type="text" style="width: 150px;" v-model='projectForm.altitude' />
						</a-col>
					</a-row>
				</div>
				<div class="frame_list_box">
					<a-row type="flex">
						<a-col :span="2" :order="1">
							<div class="frame_list_title">
								描述
							</div>
						</a-col>
						<a-col :span="22" :order="2">
							<a-textarea style="height: 150px;" v-model='projectForm.describe'></a-textarea>
						</a-col>
					</a-row>
				</div>
			</a-modal>
		</div>

	</div>
</template>

<script>
	const columns = [{
			title: '序号',
			dataIndex: 'id',
			align: 'center',
		},
		{
			title: '站名',
			dataIndex: 'name',
			align: 'center',
		},
		{
			title: '站号',
			dataIndex: 'number',
			align: 'center',
		},
		{
			title: '类型',
			dataIndex: 'type',
			align: 'center',
		},
		{
			title: '经度',
			dataIndex: 'longitude',
			align: 'center',
		},
		{
			title: '纬度',
			dataIndex: 'latitude',
			align: 'center',
		},
		{
			title: '海拔',
			dataIndex: 'altitude',
			align: 'center',
		},
		{
			title: '创建时间',
			dataIndex: 'creatime',
			align: 'center',
		},
		{
			title: '操作',
			dataIndex: 'tags',
			scopedSlots: {
				customRender: 'tags'
			},
			align: 'center',
			width: '120px'
		},
	];

	const data = [{
			id: '1',
			name: '测试站点1',
			number: 'HYC—360',
			type: '交通气象',
			longitude: '138.54125',
			latitude: '32.15624',
			altitude: '12.2',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '2',
			name: '测试站点2',
			number: 'HYC—360',
			type: '交通气象',
			longitude: '138.54125',
			latitude: '32.15624',
			altitude: '12.2',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '3',
			name: '测试站点3',
			number: 'HYC—360',
			type: '交通气象',
			longitude: '138.54125',
			latitude: '32.15624',
			altitude: '12.2',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '4',
			name: '测试站点4',
			number: 'HYC—360',
			type: '交通气象',
			longitude: '138.54125',
			latitude: '32.15624',
			altitude: '12.2',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '5',
			name: '测试站点1',
			number: 'HYC—360',
			type: '交通气象',
			longitude: '138.54125',
			latitude: '32.15624',
			altitude: '12.2',
			creatime: '2021-01-08 13:58:03',
		},
	];

	export default {
		data() {
			return {
				data, //表格内容
				columns, //表格头部
				temporary: [{
						id: '1',
						name: '测试站点1',
						number: 'HYC—360',
						type: '交通气象',
						longitude: '138.54125',
						latitude: '32.15624',
						altitude: '12.2',
						creatime: '2021-01-08 13:58:03',
					},
					{
						id: '2',
						name: '测试站点2',
						number: 'HYC—360',
						type: '交通气象',
						longitude: '138.54125',
						latitude: '32.15624',
						altitude: '12.2',
						creatime: '2021-01-08 13:58:03',
					},
					{
						id: '3',
						name: '测试站点3',
						number: 'HYC—360',
						type: '交通气象',
						longitude: '138.54125',
						latitude: '32.15624',
						altitude: '12.2',
						creatime: '2021-01-08 13:58:03',
					},
					{
						id: '4',
						name: '测试站点4',
						number: 'HYC—360',
						type: '交通气象',
						longitude: '138.54125',
						latitude: '32.15624',
						altitude: '12.2',
						creatime: '2021-01-08 13:58:03',
					},
					{
						id: '5',
						name: '测试站点1',
						number: 'HYC—360',
						type: '交通气象',
						longitude: '138.54125',
						latitude: '32.15624',
						altitude: '12.2',
						creatime: '2021-01-08 13:58:03',
					},
				],
				visible: false,
				title: '', //弹框表提
				projectForm: {
					type: 0, //类型
					name: '', //名称
					number: '', //站号
					longitude: '', //经度
					latitude: '', //纬度
					altitude: '', //海拔
					describe: '' //描述
				},
				formType: [{
						name: '选项1',
						value: 0
					},
					{
						name: '选项2',
						value: 1
					},
					{
						name: '选项3',
						value: 2
					},
				]
			};
		},
		methods: {
			addModal(e) {
				console.log(e)
				this.data = this.temporary
				Object.keys(this.projectForm).forEach(
					(key) => (this.projectForm[key] = "")
				);
				this.title = '创建站点'
				this.visible = true;
			},
			editModal(tags) {
				console.log(tags)
				var data = tags
				this.projectForm = data
				this.title = '编辑站点'
				this.visible = true;
			},
			handleOk(e) {
				this.visible = false;
			},
			handleChange(value) {
				console.log(value); // { key: "lucy", label: "Lucy (101)" }
			},
		},
	};
</script>

<style>
	@import url("../../assets/css/common.css");

	.edit_btn {
		float: left;
		color: #7F86E9;
		font-size: 12px;
		padding: 0 10px;
		text-decoration: underline;
	}

	.delete_btn {
		color: #999999;
		font-size: 12px;
		padding-right: 10px;
		text-decoration: underline;

	}
</style>
